(function () {
  'use strict';

  angular
    .module('app.exposureReportPlatform')
    .controller('exposureReportPlatformCtrl', ['measureService', 'exposureReportPlatformService', '$scope','$rootScope','$http','$filter','filterFilter', '$state', 
                                    function (measureService, exposureReportPlatformService, $scope, $rootScope, $http, $filter, filterFilter, $state) {
      
      $scope.$on('refreshDashboard', function(event, args) {
          getDataExposureReportPlatform();
      });

      var pieChartConfig = {
        options: {
          chart: {
            type: 'pie',
            zoomType: 'x',
            marginTop: 16
          },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: false
            }
          },
          
          credits: {
            enabled: false
          }
        },
        series: [{
          size: '80%',
          innerSize: '90%'
        }],
        title: {
          text: '',
          style: {
            fontSize: '16px',
            color: '#4B5567',
            fontFamily: 'ProximaNovaSemibold'
          }
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Date'
          }
        },
        noData: 'Pending Data...',
        loading: true
      };

      var pieChartConfigForPrint = {
        options: {
          chart: {
            type: 'pie',
            zoomType: 'x',
            marginTop: 22
          },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: false
            }
          },
          
          credits: {
            enabled: false
          }
        },
        series: [{
          size: '78%',
          innerSize: '90%'
        }],
        title: {
          text: '',
          y: 25,
          style: {
            fontSize: '22px',
            color: '#4B5567',
            fontFamily: 'ProximaNovaSemibold'
          }
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Date'
          }
        },
        noData: 'Pending Data...',
        loading: true
      };

      function generatePlatforms(platforms, kpiName) {
        $scope.platforms = [];

        var platform = {};
        _.forEach(platforms, function (item) {
          // chart
          platform.pieChartConfig = angular.copy(pieChartConfig);
          platform.pieChartConfig.series[0].name = item.name;
          platform.pieChartConfig.title.text = item.name;
          // chart for print
          platform.pieChartConfigForPrint = angular.copy(pieChartConfigForPrint);
          platform.pieChartConfigForPrint.series[0].name = item.name;
          platform.pieChartConfigForPrint.title.text = item.name;


          // name
          platform.name = item.platform;
          // bar
          platform.progressBar = _.get(item, 'progressBar');
          platform.contentPieChart = _.get(item, 'contentPieChart.' + kpiName);
          platform.pieChartConfig.series[0].data = [{color: platform.contentPieChart.color, y: _.get(item, 'dataPieChart.' + kpiName + '_value')}, {color: 'rgb(238, 242, 244)', y: (1-_.get(item, 'dataPieChart.' + kpiName + '_value'))}];

          platform.pieChartConfigForPrint.series[0].data = [{color: platform.contentPieChart.color, y: _.get(item, 'dataPieChart.' + kpiName + '_value')}, {color: 'rgb(238, 242, 244)', y: (1-_.get(item, 'dataPieChart.' + kpiName + '_value'))}];

          if(angular.isNumber(platform.contentPieChart.value)){
            platform.contentPieChart.value = platform.contentPieChart.value;
          }        
          $scope.platforms.push(platform);
          platform = {};
        });
      }

      function getDataExposureReportPlatform() {
        var params = $rootScope.saveParams;
        if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
          return;
        }
        params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;
        
        getExposurePlatform(params);
      }

      function getExposurePlatform(params) {
        exposureReportPlatformService.getExposurePlatform(params)
          .then(function (data) {
            $scope.exposurePlatformData = data.platforms;
            var fistExposureKPI = null;
            angular.forEach($scope.exposureKPIList, function(exposureKPI){
              if(exposureKPI.ticked == true){
                fistExposureKPI = exposureKPI.value;
              }
            });
            if(fistExposureKPI == null){
              generatePlatforms(data.platforms, "reach");
            } else{
              generatePlatforms(data.platforms, fistExposureKPI);
            }
          })
          .catch(function (msg) {
            $scope.exposurePlatformData = [];
            $scope.platforms = [];
          })
          .finally(function () {
            $rootScope.$broadcast('sectionLoaded');
          });
      }

      $scope.exposurePlatformData = [];
      $scope.exposureKPIList = [
        {label: 'Reach', value: "reach"},
        {label: 'Engagement', value: "engagement"},
        {label: 'Impression', value: "impression"}
      ];
      $scope.showExposureKPIList = function () {
        $scope.enableExposureKPIList = !$scope.enableExposureKPIList;
      }

      $scope.$watch('selectedExposureKPI', function(newValue, oldValue){
        if(newValue !== oldValue && newValue !== undefined && newValue.length != 0){         
          generatePlatforms($scope.exposurePlatformData, newValue[0].value);
        }
      });

      // first initiating
      getDataExposureReportPlatform();
      
    }]);

})();